import TutorSelectorV2 from './src/main';

/* istanbul ignore next */
TutorSelectorV2.install = function(Vue) {
  Vue.component(TutorSelectorV2.name, TutorSelectorV2);
};

export default TutorSelectorV2;
